

























































# import settings from '@/settings'
import t from '@/utils/tools'

export default {
    name: 'activities'

    props: ['payload', 'deletions']

    watch:
        payload: (new_item, old_item)->
            # console.log "WATCH ", new_item, old_item
            if Object.keys(@payload).length == 0
                @add_activity()

    data: ()->
        min: 0
        max: 10
        false: false
        activity: {
            uid: ''
            name: ''
            skill_type: 'activity'
            slug: ''
            level_waited: 5
            mandatory: false
            tasks: []
        }
        task: {
            uid: ''
            skill_type: 'activity'
            name: ''
            slug: ''
            level_waited: 5
            mandatory: false
        }

    methods:
        deep_copy: t.deep_copy

        remove_task: (index_a, index_t)->
            # console.log "DELETIONS T : ", @deletions
            if @payload[index_a]['tasks'][index_t]['uid'] != ""
                @deletions.push(@payload[index_a]['tasks'][index_t]['uid'])
            if @payload[index_a]['tasks'].length > 1
                @payload[index_a]['tasks'].splice(index_t, 1)
            else
                @payload[index_a]['tasks'][0].name = ""
                @payload[index_a]['tasks'][0].level_waited = 1
                # console.log "FIRST TASK"

        remove_activity: (index_a)->
            if @payload[index_a]['uid'] != ""
                @deletions.push(@payload[index_a]['uid'])
            # console.log "DELETIONS A : ", @deletions
            if Object.keys(@payload).length > 1
                @payload.splice(index_a, 1)
            else
                @payload[0].name = ""
                @payload[0].level_waited = 1
                # console.log "FIRST ACTIVITY"

        add_task: (index_a)->
            @payload[index_a]['tasks'].push(@deep_copy(@task))

        add_activity: ()->
            @payload.push(@deep_copy(@activity))
            @payload[Object.keys(@payload).length-1]['tasks'].push(@deep_copy(@task))
        
    beforeMount: ()->
        # console.log "ACTIVITIES COMPONENT : ", @payload
        if Object.keys(@payload).length == 0
            @add_activity()

    # updated: ()->
    #     console.log "A UPDATED"
}

